module.exports = __webpack_public_path__ + "media/images/poste-587d4a18.svg";